import { auto } from "async";
import React from "react";

export default class MediosElectronicos extends React.Component {

  componentDidMount() {
    const _modalMed = document.getElementById("containerMedios");
    const _bodyMed = document.querySelectorAll("div#div-body-modal[modal-type='medios']")[0];
    const _chage = function () {
      const h = window.innerHeight;
      _modalMed.height = h - 250;
      _modalMed.style.height = h - 250 + "px";
      _bodyMed.height = h - 100;
      _bodyMed.style.setProperty("height", h - 100 + "px", "important");
    };
    new ResizeObserver(_chage).observe(_modalMed);
    new MutationObserver(_chage).observe(_modalMed, {
      attributes: true,
      childList: true,
      characterData: true,
    });
  }

  render() {
    return ( //NOSONAR
      <div>
        <div>
          <h5 className="text-center">
            Términos y condiciones del uso de Medios Electrónicos
          </h5>
        </div>

        <div>
          <div
            style={{ height: "550px", overflowY: "auto", color: "#333333" }}
            id="containerMedios"
          >
            <p>
              <b>
                Que celebran, el Usuario que suscribe y da su aceptación al
                final del presente documento, para el uso de los Medios
                Electrónicos, y Grupo Nacional Provincial S.A.B., en adelante
                "GNP", el cual pone a su disposición para la Celebración de
                Operaciones y Prestación de Servicios Relativos a los Seguros
                que "GNP" ofrece y que el Usuario desee contratar o haya
                contratado, al tenor de las siguientes declaraciones,
                definiciones, términos y condiciones.
              </b>
            </p>
            <p>
              <b>Declaraciones</b>
            </p>
            <p>
              <b>“LAS PARTES” DECLARAN:</b>
            </p>
            <ul>
              <li>
                I. Reconocerse&nbsp; recíprocamente la personalidad y capacidad
                con las que se ostentan para todos los efectos legales a que
                haya lugar.
              </li>
              <li>
                II. Que en la manifestación de su voluntad no existe dolo,
                violencia, mala fe, error, lesión, ni ningún otro vicio de la
                voluntad por el que pudiera solicitarse la nulidad del presente
                acuerdo de voluntades. En consecuencia, las partes emiten su
                voluntad expresamente y de manera libre y espontánea al tenor de
                lo siguiente:
              </li>
            </ul>
            <p>
              <b>DEFINICIONES</b>
            </p>
            <p>
              Para los fines de este Contrato los términos definidos a
              continuación tendrán el significado que aquí se señala, sin
              perjuicio de que la referencia a los mismos sea en singular o en
              plural:
            </p>
            <p>
              <b>1. ASEGURADO</b>: es la persona física o moral que en sí misma,
              en sus bienes o intereses económicos está expuesta al riesgo
              cubierto por la Póliza de Seguro
            </p>
            <p>
              <b>2</b>. <b>AUTENTICACIÓN</b>: el conjunto de técnicas y
              procedimientos utilizados para verificar la identidad del{" "}
              <b>USUARIO</b> y su facultad para la realización de operaciones
              electrónicas y la facultad de GNP para recibir instrucciones a
              través de Medios Electrónicos.
            </p>
            <p>
              <b>3.</b> <b>BENEFICIARIO</b>: persona física y/o moral designada
              en la Póliza por el Asegurado o Contratante, como titular de los
              derechos indemnizatorios.
            </p>
            <p>
              <b>4.</b> <b>CONTRASEÑA</b>: la cadena de caracteres que autentica
              al <b>USUARIO</b> en un Medio Electrónico o en una Operación
              Electrónica;
            </p>
            <p>
              <b>5.</b> <b>CONTRATO DE SEGURO</b>: es el acuerdo de voluntades
              mediante el cual GNP se obliga, mediante una prima, a resarcir un
              daño o a pagar una suma de dinero al verificarse la eventualidad
              prevista en el contrato.
            </p>
            <p>
              <b>6. FACTOR DE AUTENTICACIÓN</b>: el mecanismo de autenticación,
              tangible o intangible, basado en las características físicas del
              usuario, en dispositivos o información que solo el usuario posea o
              conozca. Estos mecanismos pueden incluir:
            </p>
            <ul>
              <li>
                a) Información que el usuario conozca y que GNP valide a través
                de cuestionarios practicados por operadores de centros de
                atención telefónica;
              </li>
              <li>
                b) Información que solamente el usuario conozca, tales como
                contraseñas y Números de Identificación Personal (NIP);
              </li>
              <li>
                c) Información contenida o generada en medios o dispositivos
                respecto de los cuales el usuario tenga posesión, tales como
                dispositivos o mecanismos generadores de contraseñas dinámicas
                de un solo uso y tarjetas con circuito integrado, que tengan
                propiedades que impidan la duplicación de dichos medios,
                dispositivos o de la información que estos contengan o generen,
                o
              </li>
              <li>
                d) Información del usuario derivada de sus características
                físicas, tales como huellas dactilares, geometría de la mano o
                patrones en iris o retina, siempre que dicha información no
                pueda ser duplicada y utilizada posteriormente.
              </li>
            </ul>
            <p>
              <b>7. GNP</b>: Grupo Nacional Provincial S.A.B
            </p>
            <p>
              <b>8. IDENTIFICADOR DE USUARIO</b>: la cadena de caracteres,
              información de un dispositivo o cualquier otra información que
              conozca tanto GNP como el USUARIO, que permita reconocer la
              identidad del propio USUARIO para la realización de Operaciones
              Electrónicas;
            </p>
            <p>
              <b>9.</b> <b>MEDIOS ELECTRÓNICOS</b>: son los equipos, medios
              ópticos o de cualquier otra tecnología, sistemas automatizados de
              procesamiento de datos y redes de telecomunicaciones&nbsp; que{" "}
              <b>GNP</b> pone a disposición del&nbsp; <b>USUARIO</b> para la
              realización de las operaciones electrónicas; para efectos de este
              instrumento serán considerados de manera enunciativa pero no
              limitativa los siguientes:
            </p>
            <p>
              a) <b>Audio Respuesta: GNP</b> recibe instrucciones del{" "}
              <b>USUARIO</b> a través de un sistema telefónico e interactúa con
              el propio Usuario mediante grabaciones de voz y tonos o mecanismos
              de reconocimiento de voz, incluyendo los sistemas de respuesta
              interactiva de voz (IVR);
            </p>
            <p>
              b) <b>Aplicaciones Móviles</b>: aplicación específicamente
              diseñada para utilizarse en dispositivos móviles como tabletas y
              teléfonos celulares inteligentes a través de la cual <b>GNP</b>{" "}
              recibe instrucciones por parte del <b>USUARIO</b>.
            </p>
            <p>
              c) <b>Aplicaciones Web</b>:&nbsp; red electrónica mundial
              denominada Internet, en el sitio que corresponda a uno o más
              dominios de la Institución o Sociedad Mutualista, incluyendo el
              acceso mediante el protocolo WAP o alguno equivalente;
            </p>
            <p>
              d) <b>Voz a Voz (CALL CENTER)</b>: el&nbsp; <b>USUARIO</b>{" "}
              instruye vía telefónica a través de un empleado o representante
              autorizado por GNP, con funciones específicas, el cual podrá
              operar en el centro de atención telefónica (Call Center), a
              realizar operaciones a nombre del propio USUARIO;
            </p>
            <p>
              <b>10.</b> <b>MENSAJE DE TEXTO SMS</b>: mensaje de texto
              disponible para su envío en servicios de telefonía móvil.
            </p>
            <p>
              <b>11.</b> <b>OPERACIONES ELECTRÓNICAS</b>: el conjunto de
              operaciones y servicios que GNP realiza con el&nbsp; USUARIO a
              través de Medios Electrónicos, para efectos de este instrumento
              serán considerados de manera enunciativa pero no limitativa las
              siguientes:
            </p>
            <ul>
              <li>a) Contratación o cancelación de un seguro;</li>
              <li>
                b) Solicitud, aceptación o emisión de endosos a los contratos;
              </li>
              <li>
                c) Instrucciones para transferencias de recursos dinerarios a
                cuentas de GNP por concepto de pago de primas;
              </li>
              <li>d) Modificación de designación de beneficiarios;</li>
              <li>
                e) Alta y modificación del medio de notificación&nbsp; para la
                confirmación de la operación electrónica realizada.
              </li>
              <li>
                f) Consultas de estados de cuenta u otras consultas que permitan
                conocer información relacionada con el Usuario o los contratos
                que tenga celebrados con la GNP, u otra que pueda ser utilizada
                como información de Autenticación;
              </li>
              <li>
                g) Desbloqueo de Contraseñas o Números de Identificación
                Personal (NIP)
              </li>
              <li>
                h) Solicitud de pago de rescate o aplicación de valores
                garantizados.
              </li>
            </ul>
            <p>
              <b>12. PÓLIZA</b>: es el conjunto de documentos que forman parte
              integrante del contrato de seguro celebrado entre <b>GNP</b> y el
              Asegurado,&nbsp; en los cuales se estipulan&nbsp; los términos,
              condiciones, derechos y obligaciones de las partes.
            </p>
            <p>
              <b>13. SESIÓN</b>: período en el cual el <b>USUARIO</b> podrá
              llevar a cabo consultas, operaciones o transacciones, una vez que
              hayan ingresado al servicio de Operaciones Electrónicas con su
              Identificador de Usuario;
            </p>
            <p>
              <b>14. USUARIO</b>: la persona que contrata, utiliza o por
              cualquier otra causa tenga algún derecho frente a <b>GNP</b> como
              resultado del uso&nbsp; de los Medios Electrónicos de <b>GNP</b>.
            </p>
            <p>
              <b>TERMINOS Y CONDICIONES</b>
            </p>
            <p>
              <b>1. El USUARIO</b> a través de los Medios Electrónicos que{" "}
              <b>GNP&nbsp;</b> pone a su&nbsp; disposición, podrá realizar
              Operaciones Electrónicas, las cuales podrán variar de acuerdo a la
              operatividad del Medio Electrónico elegido, Póliza de Seguro y
              legislación aplicable, en sustitución de la firma autógrafa.
            </p>
            <p>
              No será responsabilidad de <b>GNP</b> habilitar la totalidad de
              las Operaciones Electrónicas&nbsp; que ofrezca en todos los Medios
              Electrónicos, siendo que se reserva el derecho de ampliar o
              disminuir el número de Operaciones Electrónicas ofrecidos en cada
              Medio Electrónico,&nbsp; así mismo GNP no será responsable frente
              al <b>USUARIO</b> por falta de disponibilidad de las Operaciones
              Electrónicas, con independencia a la causa que haya motivado a
              dicha falta
            </p>
            <p>
              Las instrucciones del <b>USUARIO</b> para convenir Operaciones
              Electrónicas&nbsp; a través de Medios Electrónicos son su estricta
              responsabilidad, por lo que GNP deberá dar cumplimiento a las
              mismas, sin tomar en cuenta la causa o motivo que originó dicha
              instrucción, y/o la implicación que tenga para la actividad del{" "}
              <b>USUARIO</b> y/o el beneficio o perjuicio que le puedan causar.
            </p>
            <p>
              <b>2. GNP</b> podrá modificar en cualquier momento el diseño,
              contenido y/o configuración de los Medios Electrónicos, así como
              de alguno o todos los servicios en ellos contenidos sin que medie
              aviso previo al <b>USUARIO</b> quien será responsable de revisar
              con regularidad los mismos. La utilización por parte del&nbsp;
              USUARIO de cualquier Medio Electrónico implica la aceptación total
              de este instrumento.
            </p>
            <p>
              <b>3. GNP</b> podrá identificar y autenticar al <b>USUARIO</b> de
              acuerdo al&nbsp; Medio&nbsp; Electrónico que éste&nbsp; elija y de
              acuerdo a la operación que se vaya realizar de acuerdo a lo
              siguiente:
            </p>
            <p>
              A.El otorgamiento al <b>USUARIO</b> de un Identificador&nbsp; de
              Usuario personal, el cual será único para permitir su apropiada e
              inequívoca identificación.
            </p>
            <p>
              B. El uso de Factores de Autenticación para comprobar su
              identidad.
            </p>
            <p>
              El <b>USUARIO</b> podrá cambiar sus Contraseñas en el momento que
              lo desee, mediante cualquiera de los Medios Electrónicos
              disponibles que tenga habilitado dicho servicio.
            </p>
            <p>
              <b>GNP</b> podrá en todo momento mejorar la calidad de los
              servicios estableciendo modificaciones a las reglas de
              funcionamiento, de acceso o procedimientos de identificación y
              autenticación.
            </p>
            <p>
              <b>GNP podrá</b> bloquear los factores de autenticación para
              impedir que el <b>USUARIO</b> pueda realizar operaciones
              electrónicas cuando detecte lo siguiente:
            </p>
            <p>
              a) El <b>USUARIO</b> no cuente con una póliza vigente.
            </p>
            <p>
              b) El <b>USUARIO</b> solicite la cancelación de los servicios de
              Medios Electrónicos.
            </p>
            <p>
              c) Después de haber ingresado incorrectamente su contraseña en
              varias ocasiones consecutivas.
            </p>
            <p>
              d) Cuando GNP detecte operaciones no habituales fuera del
              comportamiento usual del USUARIO que pueda comprometer la
              seguridad de su información.
            </p>
            <p>
              e) EL <b>USUARIO</b> no haya realizado operaciones electrónicas en
              el lapso de un año continuo.
            </p>
            <p>f) Cuando exista orden de la autoridad competente.</p>
            <p>
              g) Si <b>GNP</b> detecta que el <b>USUARIO</b> está haciendo mal
              uso de su cuenta, así como de los servicios e información
              contenidos en él.
            </p>
            <p>
              Al momento en que el <b>USUARIO</b> ingresa a los Medios
              Electrónicos, se identifica y autentica, reconoce su voluntad para
              que <b>GNP</b> realice las operaciones electrónicas que el{" "}
              <b>USUARIO</b> le instruya.
            </p>
            <p>
              Por lo anterior, las partes&nbsp; acuerdan que la autenticación e
              identificación que el <b>USUARIO</b> realice para la utilización
              de los Medios Electrónicos, será considerada la manifestación
              expresa de la voluntad del <b>USUARIO</b>
            </p>
            <p>
              4. <b>GNP</b> recomienda al <b>USUARIO</b> tomar medidas de
              seguridad en la realización de sus Operaciones Electrónicas, para
              lo cual GNP pone a su disposición algunas recomendaciones que
              puede consultar en la página www.gnp.com.mx.
            </p>
            <p>
              Las recomendaciones y consejos de <b>GNP</b> son de naturaleza
              general, por lo que no deben tomarse en cuenta en la adopción de
              decisiones personales ni profesionales. Para ello se debe
              consultar a un profesional apropiado que pueda asesorar al USUARIO
              de acuerdo con sus necesidades específicas.
            </p>
            <p>
              <b>5. LAS PARTES</b> se obligan a lo siguiente:
            </p>
            <p>
              <b>I. El USUARIO</b> se obliga:
            </p>
            <ul>
              <li>
                <b>a)</b> A resguardar y mantener su Identificador de Usuario,
                contraseña y/o cualquier información o herramienta utilizados
                para&nbsp; &nbsp;el acceso a los Medios Electrónicos y la
                realización de Operaciones Electrónicas,,&nbsp; como
                confidenciales toda vez que el uso de las mismas, será
                responsabilidad directa del <b>USUARIO</b>, aún y cuando medie
                caso fortuito o fuerza mayor, asumiendo la responsabilidad que
                su uso implica.
              </li>
              <li>
                <b>b)</b> Responder frente a <b>GNP</b> de los daños y
                perjuicios que pueda sufrir éste último, con motivo del uso de
                los Medios Electrónicos que hagan terceros o el <b>USUARIO</b>
                &nbsp; de su&nbsp; clave o contraseña, siendo el monto mínimo
                del pago la magnitud del daño causado.
              </li>
              <li>
                <b>c)</b> A reconocer&nbsp; y aceptar el carácter identificable,
                personal e intransferible de su Identificador de Usuario,
                contraseña y/o cualquier información o herramienta utilizados
                para&nbsp; &nbsp;el acceso a los Medios Electrónicos, ya que el
                empleo de dicha información es bajo su responsabilidad, por lo
                que todas las operaciones realizadas dentro de su cuenta le
                serán imputables.
              </li>
              <li>
                <b>d) </b>En caso de que el <b>USUARIO</b> tenga conocimiento o
                sospeche de cualquier violación a la seguridad, tal como el robo
                o el uso no autorizado de su <b>clave de usuario</b>, contraseña
                y/o cualquier información o herramienta utilizadas para&nbsp;
                &nbsp;el acceso a los Medios Electrónicos, deberá notificar
                inmediatamente a <b>GNP</b> a través del Call Center al
                5227-9000 en la Ciudad de México o en el interior de la
                República, para que <b>GNP</b> realice el bloqueo de su cuenta.
              </li>
              <li>
                <b>e)</b> Proporcionar a <b>GNP</b>, en el momento que se
                requiera, la información relacionada con los movimientos que
                realice en su cuenta.
              </li>
              <li>
                <b>f) </b>Reportar a GNP cualquier Operación Electrónica que el{" "}
                <b>USUARIO</b> no reconozca como propia, a través del Call
                Center al número 5227-9000 en la Ciudad de México o en el
                interior de la República.
              </li>
              <li>
                <b>g)</b> Aceptar que la información e instrucciones que el{" "}
                <b>USUARIO</b> transmita o comunique a <b>GNP</b> a través de
                los medios de autenticación e identificación que utilice para
                acceder a los Medios Electrónicos de <b>GNP</b>, así como los
                comprobantes emitidos y transmitidos a través de su cuenta
                tendrán pleno valor probatorio y fuerza legal para acreditar la
                operación realizada,&nbsp; su naturaleza, así como las
                características y alcance de sus instrucciones.
              </li>
            </ul>
            <p>
              Cualquier incumplimiento a lo&nbsp; establecido en el presente
              documento, así como las consecuencias que se generen, serán
              responsabilidad del <b>USUARIO</b>.
            </p>
            <p>
              <b>II. GNP se obliga a:</b>
            </p>
            <p>
              <b>a)</b> Mantener controles de seguridad técnicos, físicos
              y&nbsp; administrativos&nbsp; para proteger en todo momento&nbsp;
              la confidencialidad&nbsp; e integridad de la información del{" "}
              <b>USUARIO</b>, incluyendo la de sus factores de autenticación.
            </p>
            <p>
              <b>6. GNP</b> no estará obligado a realizar las operaciones&nbsp;
              que el <b>USUARIO</b> haya solicitado por cualquier Medio
              Electrónico, en los siguientes casos:
            </p>
            <p>
              i. Cuando la información transmitida sea insuficiente, inexacta,
              errónea, incompleta o ilegal.
            </p>
            <p>
              ii. Por&nbsp; caso fortuito, de fuerza mayor o por cualquier causa
              ajena al control de GNP.
            </p>
            <p>
              <b>7. GNP</b> notificará inmediatamente al <b>USUARIO</b> a través
              de los medios de comunicación cuyos datos haya proporcionado para
              tal fin, de las Operaciones Electrónicas&nbsp; realizadas a través
              de Medios Electrónicos. La notificación consistirá en una
              referencia al tipo de Operación que se haya realizado.
            </p>
            <p>
              <b>8. </b>El horario de servicio de los Medios Electrónicos de{" "}
              <b>GNP</b> será de&nbsp; las 8:00 hrs a&nbsp; las 20:00 hrs
              tratándose de Call Center y para servicio de Audio Respuesta,
              Aplicaciones Móviles y Aplicaciones Web el servicio se otorgará
              las 24hrs del día,&nbsp; la Operación Electrónica que el Asegurado
              vaya a realizar dependerá del Medio Electrónico que haya elegido y
              de acuerdo a las restricciones aplicables a cada uno.
            </p>
            <p>
              <b>9. </b>Las partes aceptan que están sujetas a lo dispuesto por
              la Ley Federal de Protección de Datos Personales en Posesión de
              los Particulares, su Reglamento, lineamientos y demás
              disposiciones que de aquélla emanen de acuerdo al aviso de
              privacidad de GNP que puede ser consultado en cualquier momento en
              la página de internet{" "}
              <a href="https://www.gnp.com.mx/" target="_blank">
                www.gnp.com.mx;
              </a>
            </p>
            <p>
              <b>10. </b>El <b>USUARIO</b> reconoce que GNP es el único y
              exclusivo titular de los derechos de dominio, propiedad industrial
              y autoral de la información y contenido de los Medios Electrónicos
              que GNP pone a su disposición para la realización de Operaciones
              Electrónicas, por lo que en virtud de este instrumento no otorga
              por ningún motivo licencia, bajo ninguna marca comercial, patente,
              derechos de autor, secreto comercial o cualquier derecho de
              propiedad intelectual, por lo que la utilización de los Medios
              Electrónicos deberá sujetarse a lo establecido en este instrumento
              , en ningún momento el USUARIO podrá duplicar o modificar los
              mismos ni será considerado licenciatario o concesionario respecto
              de los derechos antes mencionados, debiendo guardar en todo
              momento la confidencialidad respecto de cualquier información
              industrial, profesional o comercial a que en su caso tenga acceso
              con motivo del uso de Medios Electrónicos.
            </p>
            <p>
              <b>11.</b> La vigencia de este instrumento será indefinida,
              pudiendo EL <b>USUARIO</b> solicitar a GNP la terminación del
              mismo, así como&nbsp; la cancelación de su Identificador de
              usuario cuando ya no desee utilizar los Medios Electrónicos&nbsp;
              &nbsp;al Call Center al 5227-9000 en la Ciudad de México o en el
              interior de la República o bien a través de la pagina de internet
              www.gnp.com.mx, GNP podrá cancelar el acceso del <b>USUARIO</b> a
              cualquiera de los <b>MEDIOS ELECTRÓNICOS</b> sin necesidad de
              previa notificación&nbsp; a éste.
            </p>
            <p>
              <b>12.</b> Ninguna de las partes podrá ceder los derechos y las
              obligaciones que a su favor y cargo se establecen en el presente
              documento.
            </p>
            <p>
              <b>13. </b>En ningún caso <b>GNP</b> será responsable de algún
              daño, incluyendo, sin límite, daños, pérdidas, gastos directos,
              indirectos, inherentes o consecuentes que surjan en relación al
              uso de Medios Electrónicos&nbsp; &nbsp;o imposibilidad de uso por
              parte de GNP, o en relación con cualquier falla en el rendimiento,
              error, omisión, interrupción, defecto, demora en la operación o
              transmisión, virus de computadora o falla de sistema o línea o
              cualquier circunstancia fuera del control de <b>GNP</b>.
            </p>
            <p>
              <b>14.</b> Las actualizaciones que se hagan a los presentes
              términos y condiciones serán puestas a disposición del USUARIO
              para su consulta en cualquier momento en la página de internet{" "}
              <a href="https://www.gnp.com.mx/" target="_blank">
                www.gnp.com.mx.
              </a>
            </p>
            <p>
              <b>15.</b> Para efectos del presente instrumento el domicilio de{" "}
              <b>GNP</b> será el&nbsp; ubicado en Avenida Cerro de las Torres
              #395, Colonia Campestre Churubusco, Delegación Coyoacán, Código
              postal 04200 en la Ciudad de México; de igual manera,&nbsp; el
              domicilio&nbsp; del <b>USUARIO</b> será el que&nbsp; <b>GNP</b>{" "}
              tenga registrado&nbsp; en&nbsp; la documentación del expediente
              del Contrato de Seguro relacionado.
            </p>
            <p>
              <b>16. </b>Este&nbsp; instrumento constituye el acuerdo completo
              entre <b>GNP</b> y el <b>USUARIO</b> respecto de las Operaciones
              Electrónicas realizadas&nbsp; y&nbsp; los servicios otorgados a
              través de Medios&nbsp; Electrónicos.
            </p>
            <p>
              <b>17.</b> Para la interpretación, cumplimiento o&nbsp;
              controversia derivada del presente documento, las partes
              expresamente se&nbsp; someten a las leyes de los Estados Unidos
              Mexicanos&nbsp; y competencia de los&nbsp; Tribunales Competentes
              en la Ciudad de México, renunciando las partes expresamente al
              fuero que por domicilio presente o futuro pudiera corresponderles.
            </p>
            <p>
              El presente documento constituye el acuerdo total entre las partes
              y deja sin efecto cualquier otra negociación o comunicación
              sostenida entre ellas que tenga por objeto el uso de medios
              electrónicos, ya sea verbal o escrita, Y PARA CONSTANCIA DE LO
              ANTERIOR DA SU ACEPTACIÓN AL MISMO EN FORMA ELECTRÓNICA, QUEDANDO
              EL REGISTRO DE LA MISMA EN LA BITÁCORA CORRESPONDIENTE.
            </p>
            <p>&nbsp;</p>
          </div>
        </div>

        <div className="text-center aceptar-cancelar-btn mt-20">
          <button
            type="button"
            id="btn-aceptar-modal"
            className="btn orange-btn"
            data-dismiss="modal"
            style={{
              width: "100px",
              height: "36px",
              letterSpacing: "1.25px",
              padding: "0px, 16px, 0px, 16px",
            }}
          >
            Aceptar
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/gnp-registro/mediosElectronicos.cmpt.js